import _ from "underscore";

// @ts-ignore
import api from "core/api/api";
// @ts-ignore
import App from "app";
// @ts-ignore
import stringUtils from "core/utils/string-utils";

import { getDatabaseType } from "app/components/appwizard/component-wizards/wizards/common/databaseTypes";
import { isAutomatedWizard } from "app/components/appwizard/component-wizards/wizards/source/database-reader/app-services";
import { checkSourcePrivileges } from "src/modules/wizards/services";
import {
    Schema,
    Schemas,
    Tables
} from "app/components/appwizard/component-wizards/wizards/source/database-reader/models";
import { DB_PROVIDERS } from "app/components/appwizard/component-wizards/wizards/source/database-reader/configs/db-providers";

const getSourceDatabaseType = adapter => {
    const dbType = getDatabaseType(adapter);

    if (dbType === DB_PROVIDERS.MARIADBXPAND.id + "DB") {
        return DB_PROVIDERS.MARIADB.id;
    }

    return dbType;
};

const getTypes = steps => [getSourceDatabaseType(steps[0]), getDatabaseType(steps[1])];

const prepareSchemasCollection = async (model, schemas, isCDC, type) => {
    const schemasCollection = new Schemas();

    let errors = null;
    let isSchemaValidationEnabled = false;

    const steps = model.get("template")?.steps;

    if (steps) {
        const [sourceType, targetType] = getTypes(steps);

        const createSchema = isAutomatedWizard() ? true : model.get("connectionParams").get("createSchema");

        isSchemaValidationEnabled = !!createSchema
            ? await api.isSchemaValidationSupported(sourceType, targetType, createSchema, isCDC ? "CDC" : "IL")
            : false;

        model.set("isValidationSupported", isSchemaValidationEnabled);

        if (isSchemaValidationEnabled) {
            errors = await api.validateSchemaName(sourceType, targetType, schemas);
        }
    }

    if (type === DB_PROVIDERS.SPANNER.id) {
        errors = {
            ...errors,
            "": ["Schema is not supported"]
        };
    }

    _.each(schemas, schema => {
        schemasCollection.add(
            new Schema().set({
                id: schema,
                isEnabled: false,
                schemaName: schema,
                schemaDisplayName: stringUtils.encodeHtml(schema),
                tables: new Tables(),
                isDisabled: errors ? !!errors[schema]?.length : false,
                errors: errors ? errors[schema] : null
            })
        );
    });

    return schemasCollection;
};

export const BackboneValidationMethods = {
    async ValidateConnection(model, isCDC, checkPrimaryDatabase = false) {
        return model.get("connectionParams").checkConnection(isCDC, checkPrimaryDatabase);
    },

    async CheckCDCPermissions(model) {
        return model.get("connectionParams").checkCDCPermissions();
    },

    async CheckPrivileges(model, type, wizardType?: string) {
        return checkSourcePrivileges(type, model.get("connectionParams"), wizardType);
    },

    async GetSchemas(model, isCDC, type) {
        try {
            const data = await model.get("connectionParams").fetchTableWrapper(isCDC);

            if (model.get("connectionParams").isAppAdapter()) {
                if (!data.result) {
                    throw new Error(data.message);
                }

                const schemasCollection = await prepareSchemasCollection(model, data.message, isCDC, type);

                model.set(isCDC ? "channels" : "schemas", schemasCollection);

                App.vent.trigger("appwizard:retry:hide");

                return { result: true };
            }

            if (data?.result && data?.message?.length >= 1) {
                const schemasCollection = await prepareSchemasCollection(model, data.message, isCDC, type);

                model.set("schemas", schemasCollection);

                App.vent.trigger("appwizard:retry:hide");

                return { result: true };
            }

            throw new Error("Could not get all the Schemas in the database");
        } catch (e) {
            console.error("Cannot fetch schemas", e);
            throw e;
        }
    }
};
